import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import PasswordExpirationTime from "../Stores/DataStore/Enums/PasswordExpirationTime";
import HomePanel from "../Components/HomePanel/HomePanel";
import ChangePasswordPanel from "../Components/ChangePasswordPanel/ChangePasswordPanel";

class HomePage extends Component {
  render() {
    const { stores } = this.props;
    const customer = stores.currentUser.customer;
    const user = stores.currentUser.user;

    let panel = null;
    if (
      customer &&
      customer.PasswordExpirationTime !== new PasswordExpirationTime().NEVER.Key &&
      user.isPasswordExpired(customer.PasswordExpirationTime)
    ) {
      panel = <ChangePasswordPanel user={user} />;
    } else {
      panel = <HomePanel />;
    }

    return <div>{panel}</div>;
  }
}

export default inject("stores")(observer(HomePage));



// WEBPACK FOOTER //
// ./src/Pages/HomePage.js